import { CssFeatureSymbol } from '../../ioc/catharsis-ioc'
import { MeshCssFeature } from './mesh.types'
import { meshDomApplier } from './meshDomApplier'
import { mesh } from './meshCompNode'
import { meshChild } from './meshChildCompNode'
import { autoHeightWrapper } from '../autoHeightWrapper/autoHeightWrapperCompNode'
import type { BindFeature } from '@wix/thunderbolt-catharsis-ioc'
import { compInfoNodes } from '@wix/thunderbolt-component-isolation'

export const meshCssFeature: MeshCssFeature = {
	featureName: 'mesh',
	experimentName: 'OPEN_TO_ALL',
	renderableNodes: { mesh: mesh(false) },
	intermediateNodes: {
		meshChild: meshChild(false),
		autoHeightWrapper,
		compSingleLayout: compInfoNodes.compSingleLayout,
		hasResponsiveLayout: compInfoNodes.hasResponsiveLayout,
		classicRotation: compInfoNodes.classicRotation,
	},
	dataMaps: ['theme_data', 'component_properties', 'document_data', 'layout_data', 'variants_data'],
	domApplier: meshDomApplier,
}

export const editorMeshCssFeature: MeshCssFeature = {
	...meshCssFeature,
	renderableNodes: { mesh: mesh(true) },
	intermediateNodes: {
		meshChild: meshChild(true),
		autoHeightWrapper,
		compSingleLayout: compInfoNodes.compSingleLayout,
		hasResponsiveLayout: compInfoNodes.hasResponsiveLayout,
		classicRotation: compInfoNodes.classicRotation,
	},
}

export const page: BindFeature = (bind) => {
	bind(CssFeatureSymbol).toConstantValue(meshCssFeature)
}

export const editor: BindFeature = (bind) => {
	bind(CssFeatureSymbol).toConstantValue(editorMeshCssFeature)
}
